import {RegistrationStatus} from '$share/types/asset'
import {DetailDate, CommonDate} from '$share/types/common'
import {AssetOrg, Org} from '$share/types/organization'
import {MemberStatusVersion} from '$share/types/paymoney'

/** 상품유형 */
export enum ProductType {
    /** 원리금 보장 */
    CODE_01 = '01',
    /** 원리금 비보장 */
    CODE_02 = '02',
    /** 기타 */
    CODE_03 = '03',
}

export interface Account {
    id: number
    org: AssetOrg
    name: string
    nickname: string | null
    enabled: boolean
    num: string
    consent: boolean | null // 마이데이터 전송요구 여부
    status: RegistrationStatus
    createAt: DetailDate
    updateAt: DetailDate
    unused: boolean // true 면 장기미사용 계좌
    foreignCurrency: boolean // 해외계좌 여부 (true 면 해외 계좌)
}

export interface Statement<T extends Account> {
    id: number
    asset: Pick<T, 'id' | 'name' | 'nickname' | 'num'> & {
        org: Org
    }
    createAt: DetailDate
    updateAt: DetailDate
}

export interface Product<T extends Account> {
    id: number
    asset: Pick<T, 'id' | 'name' | 'nickname' | 'num'> & {
        org: Org
    }
    prodName: string
    prodNum: string
    prodType: ProductType
    currencyCode: string
    evalAmt: number
    principalAmt: number
    holdingNum: number | null
    issueDate: CommonDate | null
    expDate: CommonDate | null
    intRate: number | null
    createAt: DetailDate
    updateAt: DetailDate
}

export interface PayAccount {
    acctKey: number // id
    bnkCd: string // 은행코드
    bnkNm: string // 은행명
    acctNo: string // 계좌번호
    regCmplTime: string // 등록완료일시
    isChkCard: boolean // 체크카드 연결계좌 여부
    isPayable: boolean // 결제가능여부
    isOpenBankAccount: boolean // 오픈뱅킹계좌여부
    isPlAccount: boolean // PL 상환계좌여부
}

export interface PaymoneyAccount {
    account: string // 페이머니 계좌번호
    version: MemberStatusVersion // 페이머니 회원 상태
}

export enum ScheduledCycle {
    MONTH_01 = '01',
    MONTH_02 = '02',
    MONTH_03 = '03',
    MONTH_04 = '04',
    MONTH_05 = '05',
    MONTH_06 = '06',
    MONTH_07 = '07',
    MONTH_08 = '08',
    MONTH_09 = '09',
    MONTH_10 = '10',
    MONTH_11 = '11',
    MONTH_12 = '12',
    WEEKLY = '13',
    DAILY = '14',
    END_OF_MONTH = '15',
    OTHER = '99',
}

export enum ScheduledDate {
    DAY_01 = '01',
    DAY_02 = '02',
    DAY_03 = '03',
    DAY_04 = '04',
    DAY_05 = '05',
    DAY_06 = '06',
    DAY_07 = '07',
    DAY_08 = '08',
    DAY_09 = '09',
    DAY_10 = '10',
    DAY_11 = '11',
    DAY_12 = '12',
    DAY_13 = '13',
    DAY_14 = '14',
    DAY_15 = '15',
    DAY_16 = '16',
    DAY_17 = '17',
    DAY_18 = '18',
    DAY_19 = '19',
    DAY_20 = '20',
    DAY_21 = '21',
    DAY_22 = '22',
    DAY_23 = '23',
    DAY_24 = '24',
    DAY_25 = '25',
    DAY_26 = '26',
    DAY_27 = '27',
    DAY_28 = '28',
    DAY_29 = '29',
    DAY_30 = '30',
    DAY_31 = '31',

    MONDAY = '32',
    TUESDAY = '33',
    WEDNESDAY = '34',
    THURSDAY = '35',
    FRIDAY = '36',
    SATURDAY = '37',
    SUNDAY = '38',

    END_OF_MONTH = '39',
}

export interface ScheduledAccount {
    id: number
    asset: Pick<Account, 'id' | 'name' | 'nickname' | 'num'> & {
        org: Org
    }
    schedOrgCode: string
    schedAccNum: string
    schedAmt: number
    schedCycle: ScheduledCycle
    schedDate: ScheduledDate | null
    transMemo: string | null
    createAt: DetailDate
    updateAt: DetailDate
}
